/**
 * Row reducer for the CPT table's J-code / CPT-code cell.
 * @module updateRowData/jCodeReducer
 */
import { CptCodeWithDetailsKeys } from "../../../../../../enums/tableColumnKeys";
import { checkIfJCodeFieldHasError } from "../computeErrorStates";

/**
 * Reducer for edits to the J-code cell. Recomputes the cell's error flag
 * from the new value and the row's current PA-required status.
 *
 * @param rowDataToUpdate - Existing row snapshot.
 * @param updatedData - New J-code string entered by the user.
 * @returns New row object with the updated JCodes cell.
 */
export const updateRowDataForJCodes = (
  rowDataToUpdate: any,
  updatedData: any,
) => {
  return {
    ...rowDataToUpdate,
    [CptCodeWithDetailsKeys.JCodes]: {
      ...rowDataToUpdate[CptCodeWithDetailsKeys.JCodes],
      data: updatedData,
      hasError: checkIfJCodeFieldHasError(
        rowDataToUpdate[CptCodeWithDetailsKeys.PaRequired]?.currentStatusId,
        updatedData,
      ),
    },
  };
};
